module.exports = __webpack_public_path__ + "static/media/1909Forsythie_colored.a4812eb2.jpg";